import React from "react"
import { Outlet } from "react-router-dom"
import Header from "./Header"
import MobileNav from "./MobileNav"
import AppDownloadBanner from "./AppDownloadBanner"

const Layout = () => {
  return (
    <div className="min-h-screen bg-[var(--paper)] pb-20 lg:pb-0">
      <AppDownloadBanner />
      <Header />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <Outlet />
      </main>
      <MobileNav />
    </div>
  )
}

export default Layout
